import { Routes, RouterModule } from '@angular/router';
import { ProfileComponent } from './profile.component';
import { NgModule } from '@angular/core';

const routes: Routes = [{
	path: '',
	data: {
		title: 'Perfil de empresa',
		status: false,
		breadcrumb: "Perfil de empresa"
	},
	component: ProfileComponent
}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class ProfileRoutingModule {}


// WEBPACK FOOTER //
// ./src/app/components/profile/profile-routing.module.ts